import { Component, inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISlipResponse } from 'src/app/domain/registration/interfaces/slip.interface';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { PermissionService } from 'src/app/shared/permission.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MerchantCESComponent } from '../crud-ces/crud-ces.component';
import { MerchantTransactionsComponent } from '../components/merchant-transactions/merchant-transactions.component';
import { COLUMNS_TO_SHOW_MOBILE, COLUMNS_TO_SHOW_WEB, FILTER_CONFIG, MerchantFilter, TABLE_BUTTONS, TABLE_CONFIG_COLUMNS } from '../crud-config';
import { MerchantService } from '../crud-service';
import { filter, map, merge, of, switchMap, take } from 'rxjs';
import { FeeConfigDialogComponent } from '../../charges/components/fee-config-dialog/fee-config-dialog.component';
import { ChargePixKeySelectComponent } from '../../charges/components/charge-key-pix-config/charge-pix-key-select/charge-pix-key-select.component';
import { MatTableDataSource } from '@angular/material/table';
import { AccountDashboardService } from '../../accounts-dashboard/account-dashboard.service';
import { ReportPreviewComponent } from '../../customers/crud-index/report-preview/report-preview.component';

@Component({
    selector: 'app-charges-index',
    templateUrl: './crud-index.component.html',
    styleUrls: ['./crud-index.component.sass'],
    providers: [MerchantService]
})
export class MerchantIndexComponent extends AbstractCrudIndex<ISlipResponse> implements OnInit {
    override title = 'COMERCIANTES';
    override filterFields = FILTER_CONFIG;
    override configColumns = TABLE_CONFIG_COLUMNS;
    override displayedColumns = COLUMNS_TO_SHOW_WEB;
    override tableButtons = TABLE_BUTTONS;
    advancedFilter: MerchantFilter = {};
    currentTab = 'merchants';
    userType = 'admin';
    viewButtonBack: boolean;
    protected accountDashboardService = inject(AccountDashboardService);

    constructor(
        dialog: MatDialog,
        service: MerchantService,
        private merchantService: MerchantService,
        toastService: ToastService,
        mediaObserver: MediaObserver,
        router: Router,
        private route: ActivatedRoute,

        public permissionService: PermissionService,
    ) {
        super(dialog, service, toastService, mediaObserver, router);
        mediaObserver.asObservable().subscribe((res) => {
            this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
            this.displayedColumns = this.is_mobile
                ? COLUMNS_TO_SHOW_MOBILE
                : COLUMNS_TO_SHOW_WEB;
        });
        this.viewButtonBack = route.snapshot.data['view'];
        console.log("TESTE:", this.viewButtonBack);
    }

    ngOnInit(): void {
        this.loadData();

    }

    public resetFilter(): void {
        this.advancedFilter = {};
        this.loadData();
    }

    public loadData() {
        this.merchantService.getAllMerchants(this.advancedFilter, true).subscribe((dataWithPagination: any) => {
            const [data, length] = dataWithPagination;
            this.length = length;

            this.dataSource = new MatTableDataSource<any>(
                data.map((item: any) => {
                    item['hideEdit'] = !item.allowEdit;
                    item['hideDelete'] = !item.allowDelete;
                    return item;
                })
            );
        });
    }

    public openShow(element: any): void {
        this.openWithUnsavedGuard<MerchantCESComponent, { saved?: boolean }>(
            MerchantCESComponent,
            {
                width: '100%',
                height: '90%',
                data: {
                    type: TypeCesEnum.SHOW,
                    element,
                }
            },
            {
                deferInitialMs: 600,
                onAfterClosed: (result) => {
                    if (result?.saved) this.loadList();
                },
                confirmData: {
                    title: 'Deseja mesmo fechar?',
                    content: 'Os dados alterados ainda não foram salvos',
                    noText: 'Cancelar',
                    yesText: 'Fechar',
                },
            }
        );
    }

    public openNew(_: any): void {
        this.openWithUnsavedGuard<MerchantCESComponent, { saved?: boolean }>(
            MerchantCESComponent,
            {
                width: '100%',
                height: '90%'
            },
            {
                deferInitialMs: 600,

                onAfterClosed: (result) => {
                    if (result?.saved) this.loadList();
                },
                confirmData: {
                    title: 'Deseja mesmo fechar?',
                    content: 'Os dados alterados ainda não foram salvos',
                    noText: 'Cancelar',
                    yesText: 'Fechar',
                },
            }
        );
    }

    public openEdit(element: any): void {
        this.openWithUnsavedGuard<MerchantCESComponent, { saved?: boolean }>(
            MerchantCESComponent,
            {
                width: '100%',
                height: '90%',
                data: {
                    type: TypeCesEnum.EDIT,
                    element,
                }
            },
            {
                deferInitialMs: 600,
                onAfterClosed: (result) => {
                    if (result?.saved) this.loadList();
                },
                confirmData: {
                    title: 'Deseja mesmo fechar?',
                    content: 'Os dados alterados ainda não foram salvos',
                    noText: 'Cancelar',
                    yesText: 'Fechar',
                },
            }
        );
    }

    public openSettings(event: any): void { }

    public openTransactions(element: any): void {
        GlobalUtils.openDialog({
            dialog: this.dialog,
            dialogConfig: {
                width: '100%',
                height: '90%',
                maxWidth: '1200px'
            },
            component: MerchantTransactionsComponent,
            data: {
                canviId: element.canviId,
                documentNumber: element.documentNumber,
                merchantName: element.merchantName || element.nomeComerciante || 'Comerciante'
            }
        });
    }
    public onBack(): void {
        this.router.navigate(['my-account']);
    }

    public onUsers(): void {
        this.router.navigate(['merchants', 'users']);
    }

    public handleTableAction(event: { action: string, element: any }): void {
        switch (event.action) {
            case 'fees':
                this.openInfoFeesConfig(event);
                break;
            case 'transaction':
                this.openTransactions(event.element);
                break;
            case 'pixKeys':
                this.openPixKeysManage(event.element);
                break;
            default:
                console.error('Ação não reconhecida:', event.action);
        }
    }

    public openPixKeysManage(element: any): void {
        const ref = this.dialog.open(ChargePixKeySelectComponent, {
            width: '560px',
            maxHeight: '80vh',
            disableClose: false,
            data: { merchant: element, mode: 'select' }
        });

        ref.afterClosed().subscribe((result: any) => {
            if (result?.updated) this.loadData();
        });
    }

    public openInfoFeesConfig(event: any) {
        this.dialog.open(FeeConfigDialogComponent, {
            width: '1200px',
            height: '700px',
            data: event.element.id
        });
    }

    public override submitAdvancedFilter(element: any) {
        this.advancedFilter = element.value;
        this.loadData();
    }

    public override changePage(event: any) {
        this.advancedFilter.page = event.page;
        this.advancedFilter.limit = event.limit;

        if (this.isAdvancedFilterActive && this.lastAppliedFilter) {
            this.submitAdvancedFilter({ value: this.lastAppliedFilter } as any);
        } else {
            this.loadList();
        }
    }

    public generateReports() {
        let items = this.selection?.selectAll ? this.dataSource.data : this.selection?.items;

        if (items.length <= 0) {
            this.toastService.showInfo("Selecione pelo menos uma parcela");
            return;
        }

        const columns = [
            { header: 'Código', key: 'code', type: 'text' },
            { header: 'Nome', key: 'name', type: 'text' },
            { header: 'Cidade', key: 'city', type: 'text' },
            { header: 'Tipo', key: 'type', type: 'text' },
            { header: 'Chave Pix', key: 'pix', type: 'text', align: 'center', nowrap: true },
            { header: 'Cadastro', key: 'createdAt', type: 'date', minWidth: '115px' },
        ];

        const rows = items.map((i: any) => ({
            code: i.externalId ?? '',
            name: i.name ?? i.merchantName ?? '',
            city: i.city ?? '',
            createdAt: i.createdAt ?? '',
            pix: i.pixKey ?? '',
            cutoffDay: i.cutoffDay ?? '',
            type: i.personType ?? '',
        }));

        const payload = {
            title: 'Relatório de Comerciantes',
            columns,
            rows,
            showTotal: false,
        };

        this.accountDashboardService
            .generateReportPdf(payload)
            .subscribe({
                next: (pdfBlob: Blob) => {

                    const fileName = `relatorio-comerciantes-${new Date().toISOString().slice(0, 10)}.pdf`;

                    this.dialog.open(ReportPreviewComponent, {
                        data: {
                            blob: pdfBlob,
                            fileName: fileName
                        },
                        width: '80vw',
                        height: '90vh'
                    });

                    this.toastService.showSuccess("PRÉ-VISUALIZAÇÃO GERADA");
                },
                error: (err) => {
                    console.error('Erro ao gerar relatório PDF:', err);
                    this.toastService.showError("Erro ao gerar PDF", err);
                }
            });
    }
}
